import React, { useState } from "react";
import { Button, Menu, MenuItem } from "@mui/material";
import FilterListIcon from "@mui/icons-material/FilterList";
import { StyledButton } from "../../../CSS/Styles";

const FilterButton = ({ options, onFilterChange, loading }) => {
  const [anchorEl, setAnchorEl] = useState(null);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = (option) => {
    setAnchorEl(null);
    if (option) {
      onFilterChange(option);
    }
  };

  return (
    <>
      <StyledButton
        variant="outlined"
        startIcon={<FilterListIcon />}
        onClick={handleClick}
        sx={{ marginBottom: 2 }}
        disabled={loading}
      >
        Filter By
      </StyledButton>
      <Menu
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={() => handleClose(null)}
      >
        {options?.map((option) => (
          <MenuItem key={option?.id} onClick={() => handleClose(option)}>
            {option.label}
          </MenuItem>
        ))}
      </Menu>
    </>
  );
};

export default FilterButton;
